export enum MensajeDireccion {
    DIRECCION_ACTUALIZADA = 'La dirección del Titular se encuentra actualizada',
    DIRECCION_DESACTUALIZADA =  'Actualiza el campo dirección',
    DIRECCION_ERROR = "Por favor digite nuevamente la dirección con el tipo de vía correcto o su abreviatura. Ej; transversal, calle, carrera, diagonal, etc."
  }